module.exports = __webpack_public_path__ + "static/img/brees-2018-slide-1.db2123a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/brees-2018-slide-1.jpg
// module id = F9QF
// module chunks = 1